import React from "react";

const ChannelOne = () => <div className="center">this is the channelOne</div>;

export default ChannelOne;
